export default {
  SET_THEME: 'SET_THEME',
  LOGIN: 'LOGIN',
  SET_IS_LOGGED_IN: 'SET_IS_LOGGED_IN',
  SET_PROGRAM_LABEL: 'SET_PROGRAM_LABEL',
  SET_SIDEBAR_VISIBILITY: 'SET_SIDEBAR_VISIBILITY',
  SET_SIDEBAR_TOGGLER_VISIBILITY: 'SET_SIDEBAR_TOGGLER_VISIBILITY',
};
